import React from 'react';

const benefits = [
  {
    id: '01',
    title: 'UKENTLIGE OPPDATERINGER',
    subtitle: 'Alltid oppdatert.',
    description: 'Få de siste nyhetene om norske veier, bomstasjoner og trafikksituasjoner direkte i innboksen din hver uke.',
    tag: 'UKENTLIG',
    color: '#3B6FD4'
  },
  {
    id: '02',
    title: 'EKSKLUSIVE VEGINNSIKTER',
    subtitle: 'Kun for abonnenter.',
    description: 'Dybdeanalyser av norske veistrekninger, sesongbaserte kjøretips og ekspertråd du ikke finner andre steder.',
    tag: 'EKSKLUSIVT',
    color: '#E8630A'
  },
  {
    id: '03',
    title: 'PREMIUM INNHOLD',
    subtitle: 'Mer verdi.',
    description: 'Tidlig tilgang til nye funksjoner, spesialtilbud på NordPass-tjenester og invitasjoner til eksklusive arrangementer.',
    tag: 'PREMIUM',
    color: '#E8941A'
  }
];

const WhatToExpectSection = () => {
  return (
    <section style={{
      background: '#050A12',
      padding: '100px 5%',
      position: 'relative',
      overflow: 'hidden',
      borderTop: '1px solid rgba(255,255,255,0.06)'
    }}>
      {/* Background texture number */}
      <div style={{
        position: 'absolute', bottom: '-60px', left: '-20px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 'clamp(200px, 28vw, 360px)',
        fontWeight: 900, color: 'rgba(59,111,212,0.03)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>NP</div>
      <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Section header */}
        <div style={{ marginBottom: '64px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' }}>
            <div style={{ width: '40px', height: '1px', background: '#E8941A' }} />
            <span style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
              color: '#E8941A', letterSpacing: '0.25em', textTransform: 'uppercase'
            }}>HVA DU KAN FORVENTE</span>
          </div>
          <h2 style={{
            fontFamily: 'Impact, Arial Black, sans-serif',
            fontSize: 'clamp(42px, 6vw, 80px)',
            fontWeight: 900, color: '#EEF0F2',
            lineHeight: 0.88, letterSpacing: '-0.03em',
            textTransform: 'uppercase', margin: '0 0 8px',
            transform: 'rotate(-0.5deg)', display: 'inline-block'
          }}>DITT NYE</h2>
          <br />
          <span style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: 'clamp(36px, 5vw, 68px)',
            fontWeight: 700, color: '#3B6FD4',
            lineHeight: 0.95, letterSpacing: '-0.02em'
          }}>nyhetsbrev.</span>
        </div>

        {/* Benefits grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2px'
        }}>
          {benefits?.map((benefit, index) => (
            <div key={benefit?.id} style={{
              background: index === 1 ? 'rgba(59,111,212,0.06)' : 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.06)',
              padding: '40px 32px',
              position: 'relative',
              overflow: 'hidden',
              transition: 'background 0.2s'
            }}>
              {/* Top accent */}
              <div style={{
                position: 'absolute', top: 0, left: 0, right: 0, height: '2px',
                background: benefit?.color
              }} />

              {/* Number */}
              <div style={{
                fontFamily: 'JetBrains Mono, monospace',
                fontSize: '0.65rem', color: benefit?.color,
                letterSpacing: '0.2em', marginBottom: '20px'
              }}>{benefit?.id}</div>

              {/* Tag */}
              <div style={{
                display: 'inline-block',
                background: `${benefit?.color}18`,
                border: `1px solid ${benefit?.color}40`,
                padding: '4px 10px',
                marginBottom: '20px',
                transform: index === 1 ? 'rotate(-2deg)' : 'rotate(1deg)'
              }}>
                <span style={{
                  fontFamily: 'JetBrains Mono, monospace',
                  fontSize: '0.55rem', color: benefit?.color,
                  letterSpacing: '0.2em', textTransform: 'uppercase'
                }}>{benefit?.tag}</span>
              </div>

              <h3 style={{
                fontFamily: 'Impact, Arial Black, sans-serif',
                fontSize: 'clamp(20px, 2.5vw, 28px)',
                fontWeight: 900, color: '#EEF0F2',
                lineHeight: 0.92, letterSpacing: '-0.01em',
                textTransform: 'uppercase', marginBottom: '8px'
              }}>{benefit?.title}</h3>

              <div style={{
                fontFamily: 'Georgia, serif', fontStyle: 'italic',
                fontSize: '1rem', color: benefit?.color,
                marginBottom: '16px'
              }}>{benefit?.subtitle}</div>

              <p style={{
                fontFamily: 'Inter, sans-serif',
                fontSize: '0.875rem', color: 'rgba(238,240,242,0.55)',
                lineHeight: 1.7
              }}>{benefit?.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatToExpectSection;
